module.exports = __webpack_public_path__ + "media/images/front/pc/institution-treatment-information/bnr_300_600-843d7110bd91efc9659c543f55dd6b76.png";